var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"empty-state"},[_c('div',{staticClass:"empty-state__icon"},[_c('fa-icon',{attrs:{"icon":_vm.icon}})],1),_c('h3',{staticClass:"empty-state__title"},[_vm._v(_vm._s(_vm.title))]),(_vm.description)?_c('p',{staticClass:"empty-state__description"},[_vm._v(_vm._s(_vm.description))]):_vm._e(),_vm._t("action")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }